const Loader2 = ({ text = 'Loading...' }) => {
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  };

  const containerStyle = {
    textAlign: 'center',
    color: '#fff'
  };

  const spinnerStyle = {
    border: '6px solid #f3f3f3',
    borderTop: '6px solid #3498db',
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 10px auto'
  };

  return (
    <>
      {/* Spinner keyframe animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      <div style={overlayStyle}>
        <div style={containerStyle}>
          <div style={spinnerStyle}></div>
          <p>{text}</p>
        </div>
      </div>
    </>
  );
};

export default Loader2;
